import { useEffect } from 'react'
import { Dimensions, Platform, StyleSheet } from 'react-native'
import Animated, {
  Easing,
  interpolate,
  useAnimatedStyle,
  useSharedValue,
  withDelay,
  withTiming
} from 'react-native-reanimated'

export const EMOJI_ANIM_DURATION = 3200

const EMOJI_SIZE = 30

const { width: WIDTH, height: HEIGHT } = Dimensions.get('screen')

const responsiveScreenWidth = Platform.OS === 'web' ? (WIDTH > 500 ? 500 : WIDTH) : WIDTH

const getRandomRelativePosition = () => {
  const x = Math.random() * (responsiveScreenWidth - EMOJI_SIZE)
  const y = EMOJI_SIZE + Math.random() * 100

  return { x, y }
}

export const AnimatedEmoji = ({ emoji }: { emoji: string }) => {
  const initialPosition = getRandomRelativePosition()

  const fly = useSharedValue(0)

  const rotate = Math.floor(Math.random() * 100) % 2 === 0 ? 20 : -20

  const transform = [
    {
      rotate: `${rotate}deg`
    }
  ]

  const positionStyles = useAnimatedStyle(() => {
    return {
      left: initialPosition.x,
      bottom: interpolate(fly.value, [0, 1], [initialPosition.y, HEIGHT])
    }
  }, [initialPosition])

  useEffect(() => {
    fly.value = withDelay(
      50,
      withTiming(1, {
        duration: EMOJI_ANIM_DURATION,
        easing: Easing.bezier(0.25, 0.1, 0.25, 1)
      })
    )

    return () => {
      fly.value = 0
    }
  }, [fly])

  return <Animated.Text style={[styles.emoji, { transform }, positionStyles]}>{emoji}</Animated.Text>
}

const styles = StyleSheet.create({
  emoji: {
    position: 'absolute',
    fontSize: EMOJI_SIZE
  }
})
